import React, { Component, PropTypes } from 'react';
import ModalConfirmationSettings from '../../modals/ModalConfirmationSettings';

class PagesCalendar extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div>
                Content of Calendar
                <hr />
                {this.props.children}
            </div>
        );
    }
}

PagesCalendar.propTypes = {
    children: PropTypes.element
};

PagesCalendar.contextTypes = {
    store: PropTypes.object
};

export default PagesCalendar;



// WEBPACK FOOTER //
// ./src/components/pages/pages/PagesCalendar.js